import React from "react";
export function Hook() {
    return (React.createElement("div", { className: "ltg-hook-wrap" },
        React.createElement("div", { className: "ltg-hook-top" },
            React.createElement("div", { className: "ltg-hook-filler" }),
            React.createElement("div", { className: "ltg-hook-corner" })),
        React.createElement("div", { className: "ltg-hook-bottom" },
            React.createElement("div", { className: "ltg-hook-filler" }),
            React.createElement("div", { className: "ltg-hook-circle" }))));
}
